import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'

export default function Asynchronous({
  options,
  renderInput,
  onChange = (value) => console.log(value),
  getOptionSelected = (option, value) => option.name === value.name,
  getOptionLabel = (option) => option.name,
  ...others
}) {
  const [open, setOpen] = React.useState(false)
  const loading = open && options.length === 0

  return (
    <Autocomplete
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onClose={() => {
        setOpen(false)
      }}
      getOptionSelected={getOptionSelected}
      getOptionLabel={getOptionLabel}
      options={options}
      clearOnEscape
      disableClearable
      onChange={(e, value) => {
        onChange(value)
      }}
      renderInput={(params) => renderInput(params)}
      loading={loading}
      {...others}
    />
  )
}
